export enum CodeError {
	INELIGIBLE_CUSTOMER = 'SPP001',
	OTP_GENERATION_LIMIT = 'SPP002',
	OTP_VALIDATE_LIMIT = 'SPP003',
	INVALID_TAX_FOLDER_PASSWORD = 'SPGS001',
}

export enum ErrorContentName {
	INELIGIBLE_CUSTOMER = 'INELIGIBLE_CUSTOMER',
	GENERIC_ERROR = 'GENERIC_ERROR',
	NO_CONNECTION = 'NO_CONNECTION',
	OTP_LIMIT = 'OTP_LIMIT',
	INVALID_TAX_FOLDER_PASSWORD = 'INVALID_TAX_FOLDER_PASSWORD',
	PURPOSES_ERROR = 'PURPOSES_ERROR',
}

export enum ModalContentKey {
	ABANDON_MODAL = 'ABANDON_MODAL',
}

export enum NotificationType {
	SMS = 'SMS',
	WHATSAPP = 'WHATSAPP',
	DEFAULT = 'DEFAULT',
}

export enum snackbarType {
	WARNING = 'warning',
	SUCCESS = 'success',
	ERROR = 'error',
}

export enum SnackbarMessageKey {
	OTP_SENT = 'OTP_SENT',
	OTP_EXPIRED = 'OTP_EXPIRED',
	VALIDATION_ERROR = 'VALIDATION_ERROR',
	CTE_PASSWORD_ERROR = 'CTE_PASSWORD_ERROR',
}
